<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 32"
    class="icon-svg icon-amex"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <g
        transform="translate(-1344 -906) translate(1176 140) translate(0 614) translate(0 152) translate(168)"
      >
        <rect
          width="47"
          height="31"
          x=".5"
          y=".5"
          stroke="#d5d5d5"
          fill="#FFFFFF"
          rx="4"
        />
        <g fill-rule="nonzero">
          <path
            fill="#253B80"
            d="M3.678 14.758l.265-1.682-.59-.014H.537L2.494.654c.012-.078.08-.136.159-.136h4.748c1.576 0 2.664.328 3.232.976.266.304.436.62.518.97.086.367.088.805.004 1.339l-.007.039v.342l.267.15c.203.104.386.243.539.412.228.26.375.59.437.98.064.403.043.882-.062 1.424-.122.624-.318 1.167-.583 1.611-.234.398-.549.743-.924 1.013-.352.25-.771.44-1.244.561-.459.12-.982.18-1.555.18h-.37c-.264 0-.52.095-.722.265-.201.173-.335.411-.377.673l-.028.151-.467 2.964-.022.109c-.005.034-.015.051-.029.063-.014.011-.03.017-.049.018H3.678z"
            transform="translate(17 8)"
          />
          <g>
            <path
              fill="#179BD7"
              d="M11.667 3.881c-.014.09-.03.183-.049.278-.626 3.215-2.768 4.326-5.504 4.326H4.72c-.335 0-.617.243-.669.573L3.34 13.58l-.202 1.282c-.016.103.013.208.08.288.068.079.167.124.272.124h2.47c.293 0 .542-.212.588-.5l.024-.126.465-2.952.03-.162c.046-.29.295-.502.587-.502h.37c2.393 0 4.267-.972 4.815-3.785.229-1.175.11-2.156-.495-2.846-.192-.213-.421-.39-.676-.521z"
              transform="translate(17 8)"
            />
            <path
              fill="#222D65"
              d="M11.012 3.62c-.2-.058-.404-.103-.61-.135-.406-.063-.816-.093-1.227-.09H5.453c-.292 0-.542.213-.586.502l-.792 5.015-.023.146c.051-.33.335-.573.669-.573h1.393c2.736 0 4.878-1.111 5.504-4.326.019-.095.035-.187.049-.278-.165-.087-.338-.16-.515-.217-.047-.016-.093-.03-.14-.044z"
              transform="translate(17 8)"
            />
            <path
              fill="#253B80"
              d="M4.867 3.897c.044-.29.293-.502.586-.501h3.722c.44 0 .852.028 1.228.09.254.04.505.099.75.178.184.061.356.133.514.217.187-1.188-.001-1.997-.644-2.73C10.315.346 9.037 0 7.402 0H2.653c-.334 0-.619.243-.67.574L.005 13.109c-.019.118.015.238.093.329.077.09.19.143.31.143h2.93l.737-4.67.792-5.014z"
              transform="translate(17 8)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
